import { Card, Col, Row, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { AppStateContext } from "../../context/AppContext";
import useRequest from "../../hooks/useRequest";
import ContactUs from "./_ContactUs";
import lang from "../../helper/langHelper";
import Faq from "./_Faq";
import Main from "../../components/layout/Main";

const { TabPane } = Tabs;

const notificationTabs = {
  FAQ: lang("FAQ"),
  CONTACT: lang("Contact Us"),
};

function Index() {
  const { request } = useRequest();

  const [selectedTab, setSelectedTab] = useState(notificationTabs.FAQ);

  const handleTabChange = (status) => {
    setSelectedTab(status);
  };

  return (
    <>

      <div className="tabled quoteManagement">
        <Card bordered={false} className="criclebox tablespace mb-24">
          <Tabs
            className="main_tabs"
            onTabClick={handleTabChange}
            activeKey={selectedTab}
            tabBarStyle={{ color: "green" }}
          >
            <TabPane tab={notificationTabs.FAQ} key={notificationTabs.FAQ}>
              <div className="notification-main-wrap">
                <Faq />
              </div>
            </TabPane>

            <TabPane
              tab={notificationTabs.CONTACT}
              key={notificationTabs.CONTACT}
            >
              <ContactUs />
            </TabPane>
          </Tabs>
        </Card>
      </div>

    </>
  );
}

export default Index;
